// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"4228":"2-polyfill-fetch","10201":"4-feat-protobuf-root","24588":"2-polyfill-intersectionobserver","26996":"4-auth-msal","88491":"2-polyfill-idle","95416":"2-polyfill-usertiming","99739":"2-polyfill-resizeobserver"}[chunkId] + ".js";
};